import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import Card from "../../components/Cards/Card";
import CardWrapper from "../../components/LayoutCardsWrapper/CardWrapper";
import LayoutCardsWrapper from "../../components/LayoutCardsWrapper/LayoutCardsWrapper";
import Modal from "../../components/Modal/Modal";
import NativeObject from "../../components/NativeObject/NativeObject";
import { useQlik } from "../../context/Qlik";

function DashboardDesktop({ app, config }) {
  const { setSwitchOnDemand } = useQlik();
  const { container } = config.dashboard;
  const [vCrescFaturamento, setVCrescFaturamento] = useState("");

  const [selectPeriodo, setSelectPeriodo] = useState("");
  const [selectTipoSelecao, setSelectTipoSelecao] = useState("");
  const [interacoes, setInteracoes] = useState(false);
  const [modalOpened, setModalOpened] = useState(false);

  function showModal() {
    setModalOpened(true);
  }
  function closeModal() {
    setModalOpened(false);
  }

  const initializeField = () => {
    app.variable.getContent("vCrescFaturamento", (reply) => {
      const data = reply.qContent.qString;
      setVCrescFaturamento(data);
    });
  };

  useEffect(() => {
    if (app) {
      initializeField();
    }
  }, [app]);

  useEffect(() => {
    setSwitchOnDemand(false);
  });

  return (
    <div className="app dashboard">
      <div className="appContent">
        {modalOpened && (
          <Modal
            title="Conjuntos"
            show={modalOpened}
            setShow={() => closeModal()}
            closeButton
          >
            <Card
              exportTable
              exportTableId={"vpEjV"}
              app={app}
              style={{ width: "100%", height: "100%" }}
            >
              <NativeObject app={app} reference={{ id: "vpEjV" }} />
            </Card>
          </Modal>
        )}

        <LayoutCardsWrapper>
          <CardWrapper
            customStyle={{
              paddingBottom: "0px",
              height: "10%",
              display: "flex",
              flexDirection: "row",
            }}
          >
            <Card style={{ width: "30%", height: "80%" }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  height: "100%",
                  width: "100%",
                }}
              >
                <button
                  onClick={() => setInteracoes(true)}
                  style={{ width: "100%", height: "100%" }}
                >
                  <NativeObject
                    app={app}
                    reference={{ id: interacoes ? "mXdNPZm" : "DPBEEYk" }}
                  />
                </button>
                <button
                  onClick={() => setInteracoes(false)}
                  style={{ marginLeft: "10px", width: "100%", height: "100%" }}
                >
                  <NativeObject
                    app={app}
                    reference={{ id: interacoes ? "aeYYA" : "Kyeejd" }}
                  />
                </button>
              </div>
            </Card>
          </CardWrapper>

          {interacoes ? (
            // Comportamento Produtos
            <CardWrapper
              customStyle={{
                paddingBottom: "0px",
                height: "90%",
                display: "flex",
                flexDirection: "row",
              }}
            >
              {/* Mapa de vendas */}
              <div
                style={{
                  width: "43%",
                  height: "100%",
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <Card
                  header={{
                    tooltip: container[9].cards[0].title.tooltip,
                    hardTitle: container[9].cards[0].title.hardTitle,
                    hardSubtitle: container[9].cards[0].subtitle.hardSubtitle,
                  }}
                  expandable
                  style={{ width: "100%" }}
                >
                  <NativeObject
                    app={app}
                    key={container[9].cards[0].nativeObject.valueId}
                    reference={{ id: container[9].cards[0].nativeObject.id }}
                    style={{ width: "100%", height: "92%" }}
                  />
                  <NativeObject
                    app={app}
                    reference={{ id: "TzucvS" }}
                    style={{
                      width: "100%",
                      height: "8%",
                      color: "4B81D0",
                    }}
                  />
                </Card>
              </div>

              <CardWrapper
                customStyle={{
                  paddingBottom: "0px",
                  paddingRight: "0px",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <CardWrapper
                  customStyle={{
                    paddingRight: "0px",
                    height: "50%",
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  {/* Ranking produtos */}
                  <div
                    style={{
                      width: "50%",
                      height: "100%",
                      display: "flex",
                      flexDirection: "row",
                    }}
                  >
                    <Card
                      header={{
                        tooltip: container[9].cards[1].title.tooltip,
                        hardTitle: container[9].cards[1].title.hardTitle,
                      }}
                      expandable
                      exportTable
                      exportTableId={container[9].cards[1].nativeObject.id}
                      app={app}
                      style={{ width: "100%", height: "100%" }}
                    >
                      <NativeObject
                        app={app}
                        key={container[9].cards[1].nativeObject.valueId}
                        reference={{
                          id: container[9].cards[1].nativeObject.id,
                        }}
                      />
                    </Card>
                  </div>

                  {/* Comportamento clientes */}
                  <div
                    style={{
                      width: "50%",
                      height: "100%",
                      display: "flex",
                      flexDirection: "row",
                    }}
                  >
                    <Card
                      header={{
                        tooltip: container[9].cards[2].title.tooltip,
                        hardTitle: container[9].cards[2].title.hardTitle,
                      }}
                      expandable
                      exportTable
                      exportTableId={container[9].cards[2].nativeObject.id}
                      app={app}
                      style={{ width: "100%", height: "100%" }}
                    >
                      <NativeObject
                        app={app}
                        key={container[9].cards[2].nativeObject.valueId}
                        reference={{
                          id: container[9].cards[2].nativeObject.id,
                        }}
                      />
                    </Card>
                  </div>
                </CardWrapper>

                <CardWrapper
                  customStyle={{
                    paddingBottom: "20px",
                    paddingRight: "0px",
                    height: "50%",
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  {/* Clientes com produtos */}
                  <div
                    style={{
                      width: "50%",
                      height: "100%",
                      display: "flex",
                      flexDirection: "row",
                    }}
                  >
                    <Card
                      header={{
                        tooltip: container[9].cards[3].title.tooltip,
                        hardTitle: container[9].cards[3].title.hardTitle,
                      }}
                      expandable
                      exportTable
                      exportTableId={container[9].cards[3].nativeObject.id}
                      app={app}
                      style={{ width: "100%", height: "100%" }}
                    >
                      <NativeObject
                        app={app}
                        key={container[9].cards[3].nativeObject.valueId}
                        reference={{
                          id: container[9].cards[3].nativeObject.id,
                        }}
                      />
                    </Card>
                  </div>

                  {/* Melhore resultados */}
                  <div
                    style={{
                      width: "50%",
                      height: "100%",
                      display: "flex",
                      flexDirection: "row",
                    }}
                  >
                    <Card
                      header={{
                        tooltip: container[9].cards[4].title.tooltip,
                        hardTitle: container[9].cards[4].title.hardTitle,
                      }}
                      expandable
                      exportTable
                      exportTableId={container[9].cards[4].nativeObject.id}
                      app={app}
                      style={{ width: "100%", height: "100%" }}
                    >
                      <NativeObject
                        app={app}
                        key={container[9].cards[4].nativeObject.valueId}
                        reference={{
                          id: container[9].cards[4].nativeObject.id,
                        }}
                      />
                    </Card>
                  </div>
                </CardWrapper>
              </CardWrapper>
            </CardWrapper>
          ) : (
            // Comportamento Clientes
            <CardWrapper
              customStyle={{
                paddingBottom: "0px",
                height: "90%",
                display: "flex",
                flexDirection: "row",
              }}
            >
              <CardWrapper
                customStyle={{
                  paddingBottom: "0px",
                  paddingRight: "0px",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <CardWrapper
                  customStyle={{
                    paddingRight: "0px",
                    height: "50%",
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  {/* Recorrência dos clientes */}
                  <div
                    style={{
                      width: "50%",
                      height: "100%",
                      display: "flex",
                      flexDirection: "row",
                    }}
                  >
                    <Card
                      header={{
                        tooltip: container[10].cards[0].title.tooltip,
                        hardTitle: container[10].cards[0].title.hardTitle,
                      }}
                      expandable
                      exportTable
                      exportTableId={container[10].cards[1].nativeObject.id}
                      app={app}
                      style={{ width: "100%", height: "100%" }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          height: "100%",
                          width: "100%",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            height: "100%",
                            width: "75%",
                          }}
                        >
                          <NativeObject
                            app={app}
                            key={container[10].cards[0].nativeObject.valueId}
                            reference={{
                              id: container[10].cards[0].nativeObject.id,
                            }}
                            style={{
                              width: "100%",
                              height: "90%",
                            }}
                          />
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              height: "10%",
                              width: "100%",
                            }}
                          >
                            <NativeObject
                              app={app}
                              reference={{ id: "TzkpRf" }}
                              style={{
                                width: "50%",
                                height: "100%",
                              }}
                            />

                            <button
                              onClick={() => showModal()}
                              style={{
                                marginLeft: "10px",
                                width: "50%",
                                height: "100%",
                              }}
                            >
                              <NativeObject
                                app={app}
                                reference={{ id: "RcpdXZp" }}
                              />
                            </button>
                          </div>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            height: "100%",
                            width: "35%",
                          }}
                        >
                          <NativeObject
                            app={app}
                            key={container[10].cards[1].nativeObject.valueId}
                            reference={{
                              id: container[10].cards[1].nativeObject.id,
                            }}
                          />
                        </div>
                      </div>
                    </Card>
                  </div>

                  {/* Comportamento dos clientes por mês */}
                  <div
                    style={{
                      width: "50%",
                      height: "100%",
                      display: "flex",
                      flexDirection: "row",
                    }}
                  >
                    <Card
                      header={{
                        tooltip: container[10].cards[2].title.tooltip,
                        hardTitle: container[10].cards[2].title.hardTitle,
                      }}
                      expandable
                      exportTable
                      exportTableId={container[10].cards[2].nativeObject.id}
                      app={app}
                      style={{ width: "100%", height: "100%" }}
                    >
                      <NativeObject
                        app={app}
                        key={container[10].cards[2].nativeObject.valueId}
                        reference={{
                          id: container[10].cards[2].nativeObject.id,
                        }}
                      />
                    </Card>
                  </div>
                </CardWrapper>

                <CardWrapper
                  customStyle={{
                    paddingBottom: "20px",
                    paddingRight: "0px",
                    height: "50%",
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  {/* Ranking Clientes mensais */}
                  <div
                    style={{
                      width: "33%",
                      height: "100%",
                      display: "flex",
                      flexDirection: "row",
                    }}
                  >
                    <Card
                      header={{
                        tooltip: container[10].cards[3].title.tooltip,
                        hardTitle: container[10].cards[3].title.hardTitle,
                      }}
                      expandable
                      exportTable
                      exportTableId={container[10].cards[3].nativeObject.id}
                      app={app}
                      style={{ width: "100%", height: "100%" }}
                    >
                      <NativeObject
                        app={app}
                        key={container[10].cards[3].nativeObject.valueId}
                        reference={{
                          id: container[10].cards[3].nativeObject.id,
                        }}
                      />
                    </Card>
                  </div>

                  {/* Comportamento de Clientes por período */}
                  <div
                    style={{
                      width: "33%",
                      height: "100%",
                      display: "flex",
                      flexDirection: "row",
                    }}
                  >
                    <Card
                      header={{
                        tooltip: container[10].cards[4].title.tooltip,
                        hardTitle: container[10].cards[4].title.hardTitle,
                      }}
                      expandable
                      exportTable
                      exportTableId={container[10].cards[4].nativeObject.id}
                      app={app}
                      style={{ width: "100%", height: "100%" }}
                    >
                      <NativeObject
                        app={app}
                        key={container[10].cards[4].nativeObject.valueId}
                        reference={{
                          id: container[10].cards[4].nativeObject.id,
                        }}
                      />
                    </Card>
                  </div>

                  {/* Melhore seus resultados: */}
                  <div
                    style={{
                      width: "34%",
                      height: "100%",
                      display: "flex",
                      flexDirection: "row",
                    }}
                  >
                    <Card
                      header={{
                        tooltip: container[10].cards[5].title.tooltip,
                        hardTitle: container[10].cards[5].title.hardTitle,
                      }}
                      expandable
                      exportTable
                      exportTableId={container[10].cards[5].nativeObject.id}
                      app={app}
                      style={{ width: "100%", height: "100%" }}
                    >
                      <NativeObject
                        app={app}
                        key={container[10].cards[5].nativeObject.valueId}
                        reference={{
                          id: container[10].cards[5].nativeObject.id,
                        }}
                      />
                    </Card>
                  </div>
                </CardWrapper>
              </CardWrapper>
            </CardWrapper>
          )}
        </LayoutCardsWrapper>
      </div>
    </div>
  );
}

DashboardDesktop.defaultProps = {
  app: null,
  config: {},
};

DashboardDesktop.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default DashboardDesktop;
